import StyledMediumModal from './StyledMediumModal'

const MediumModal = props => (<StyledMediumModal {...props} />)

export default MediumModal
